import type { JSX } from "react";
import type { CriterionProgress, CriterionStatus } from "../api/types";

interface CriterionProgressMeterProps {
  progress: readonly CriterionProgress[];
}

function countStatus(progress: readonly CriterionProgress[], status: CriterionStatus): number {
  return progress.filter((criterion) => criterion.status === status).length;
}

/** Shows aggregate criterion statuses without exposing hidden criterion content. */
export function CriterionProgressMeter({ progress }: CriterionProgressMeterProps): JSX.Element {
  const metCount = countStatus(progress, "met");
  const partialCount = countStatus(progress, "partial");
  const notMetCount = countStatus(progress, "notMet");
  const total = progress.length;

  return (
    <section className="criterion-meter" aria-label="Fremdrift">
      <div className="meter-heading">
        <h2>Fremdrift</h2>
        <strong>{metCount} av {total} kriterier oppfylt</strong>
      </div>
      <progress max={Math.max(total, 1)} value={metCount} />
      <ul className="status-counts">
        <li><span className="status-dot met" />Oppfylt: {metCount}</li>
        <li><span className="status-dot progressing" />Delvis: {partialCount}</li>
        <li><span className="status-dot pending" />Ikke oppfylt: {notMetCount}</li>
      </ul>
    </section>
  );
}
